import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { readAsText } from '@files-ui/react';
import Dialog from '../../components/DraggableModal';
import { Dropzone } from '../../components/Dropzone';
import { selectors } from '../../store/dux/field-boundary-management-dux';
import { usePrevious } from '../../hooks';

export function UploadBoundary(props) {
  const { field, handleSave, handleClose } = props;
  const [files, setFiles] = useState([]);
  const isWorking = useSelector(selectors.isWorking);
  const wasWorking = usePrevious(isWorking);
  const hasErrored = useSelector(selectors.error);

  useEffect(() => {
    if (wasWorking && !isWorking && !hasErrored) {
      handleClose();
    }
  }, [handleClose, hasErrored, isWorking, wasWorking]);

  return (
    <Dialog
      maxWidth="md"
      title={`Upload Boundary - ${field.fieldName}`}
      fullWidth
      handleClose={handleClose}
      contentOptions={{ dividers: true }}
      actions={buildActions()}
      noMinHeight
    >
      <Dropzone
        onChange={setFiles}
        fileType="geojson"
        accept=".json,.geojson"
        maxFiles={1}
      />
    </Dialog>
  );

  async function save() {
    const geojson = await readAsText(files[0]);
    const shape = JSON.parse(geojson);
    handleSave({ ...field, shape });
  }

  function buildActions() {
    return (
      <>
        <Button
          disabled={isWorking}
          color="dark"
          variant="contained"
          onClick={handleClose}
        >
          Cancel
        </Button>
        <LoadingButton
          disabled={files.length !== 1}
          loading={isWorking}
          color="primary"
          variant="contained"
          onClick={save}
        >
          Upload
        </LoadingButton>
      </>
    );
  }
}
